import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledApiListWrapper = styled.div`
  margin: 0 ${({ theme }) => `-${theme.mainSpacing}`};
`;
